export const Eduactiondata = [
    {
        Degree: "B.Tech" ,
        Specialization: "Mechanical Engineering",
        Percentage:"8.83cgpa",
        Organisation: "GIET University",
        Place: "Gunupur,Odisha",
        Year:"2018-2022",
        clgLogo:require("../../assets/education/giet.jpg"),

    },
    {
        Degree: "Intermidiate" ,
        Specialization: "Science",
        Percentage:"65%",
        Organisation: "GVJC",
        Place: "Berhampur,Odisha",
        Year:"2016-2018",
        clgLogo:require("../../assets/education/gvjc.png"),
    },
    {
        Degree: "Matriculation" ,
        Specialization: "Science",
        Percentage:"71%",
        Organisation: "Hatiota Nodal School",
        Place: "Ganjam,Odisha",
        Year:"2016",
        clgLogo:require("../../assets/education/ssvm.png"),
    }
]